import { useState } from "react";
import liverpoolStreet from "../../assets/LiverpoolStreet.png";
import onlineTherapy from "../../assets/onlineTherapy.png";

export default function BenAppointments() {
  const [activeLocation, setActiveLocation] = useState(null);

  return (
    <section id="appointments" className="py-5 benAboutSection">
      <div className="profile-container">
        <div className="benAboutIntro mb-4">
          <div className="benAboutEyebrowWrap">
            <span className="benAboutEyebrowLine"></span>
            <p className="benAboutEyebrow mb-0">WAYS TO MEET</p>
            <span className="benAboutEyebrowLine"></span>
          </div>

          <h1 className="brand-text-dark mb-0">Appointments</h1>
          <p className="brand-text-light fw-bold mb-0">
            In person and online options
          </p>
        </div>

        <div className="row g-4">
          <div className="col-12">
            <div className={`appointment-card ${activeLocation === "london" ? "appointment-card-expanded" : ""}`}>
              <div className="row g-3 align-items-center">
                <div className={activeLocation === "london" ? "col-md-4" : "col-5"}>
                  <img
                    src={liverpoolStreet}
                    alt="Liverpool Street London"
                    className="img-fluid square-crop appointment-image w-100"
                  />
                </div>

                <div className={activeLocation === "london" ? "col-md-8" : "col-7"}>
                  <h3 className="brand-text-light h5 mb-1">Face to Face</h3>
                  <p className="brand-text-gray mb-3">
                    In person sessions at our Liverpool Street location.
                  </p>

                  {activeLocation === "london" && (
                    <>
                      <p className="text-secondary mb-3">
                        Liverpool Street, London E1 7LF
                      </p>

                      <p className="text-secondary mb-4">
                        Private one to one sessions in a calm Central London
                        setting.
                      </p>

                      <ul className="list-unstyled text-secondary mb-4">
                        <li className="mb-2">✔ One to one confidential sessions</li>
                        <li className="mb-2">✔ Central London location</li>
                        <li>✔ Stress, anxiety, and wellbeing support</li>
                      </ul>
                    </>
                  )}

                  <button
                    type="button"
                    className="btn btn-dark"
                    onClick={() =>
                      setActiveLocation(activeLocation === "london" ? null : "london")
                    }
                  >
                    {activeLocation === "london" ? "Show less" : "Find out more"}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12">
            <div className={`appointment-card ${activeLocation === "online" ? "appointment-card-expanded" : ""}`}>
              <div className="row g-3 align-items-center">
                <div className={activeLocation === "online" ? "col-md-4" : "col-5"}>
                  <img
                    src={onlineTherapy}
                    alt="Online therapy"
                    className="img-fluid square-crop appointment-image w-100"
                  />
                </div>

                <div className={activeLocation === "online" ? "col-md-8" : "col-7"}>
                  <h3 className="brand-text-light h5 mb-1">Online</h3>
                  <p className="brand-text-gray mb-3">
                    Secure video appointments from anywhere.
                  </p>

                  {activeLocation === "online" && (
                    <>
                      <p className="text-secondary mb-3">
                        Secure video sessions from anywhere
                      </p>

                      <p className="text-secondary mb-4">
                        Private one to one support with the comfort of joining
                        from your home, workplace, or any space you feel relaxed
                        in.
                      </p>

                      <ul className="list-unstyled text-secondary mb-4">
                        <li className="mb-2">✔ Secure video sessions</li>
                        <li className="mb-2">✔ No travel required</li>
                        <li>✔ Flexible scheduling worldwide</li>
                      </ul>
                    </>
                  )}

                  <button
                    type="button"
                    className="btn btn-dark"
                    onClick={() =>
                      setActiveLocation(activeLocation === "online" ? null : "online")
                    }
                  >
                    {activeLocation === "online" ? "Show less" : "Find out more"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}